import { FileText, Clock, AlertTriangle, TrendingUp } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import type { OpportunityStats } from '../../types/internal-opportunity.types';

interface OpportunitiesStatsProps {
  stats?: OpportunityStats;
  isLoading?: boolean;
}

export function OpportunitiesStats({ stats, isLoading }: OpportunitiesStatsProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
      notation: 'compact',
    }).format(amount);
  };

  const items = [
    {
      label: 'Total',
      value: stats?.total ?? '-',
      icon: FileText,
      color: 'text-blue-600',
      bgColor: 'bg-blue-100',
    },
    {
      label: 'Bientôt dues',
      value: stats?.dueSoon ?? '-',
      icon: Clock,
      color: 'text-amber-600',
      bgColor: 'bg-amber-100',
    },
    {
      label: 'En retard',
      value: stats?.overdue ?? '-',
      icon: AlertTriangle,
      color: 'text-red-600',
      bgColor: 'bg-red-100',
    },
    {
      label: 'Valeur totale',
      value: stats?.totalValue ? formatCurrency(stats.totalValue) : '-',
      icon: TrendingUp,
      color: 'text-green-600',
      bgColor: 'bg-green-100',
    },
  ];

  return (
    <div className="grid gap-4 grid-cols-2 lg:grid-cols-4">
      {items.map((item) => (
        <Card key={item.label}>
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className={`p-2 rounded-lg ${item.bgColor}`}>
                <item.icon className={`h-5 w-5 ${item.color}`} />
              </div>
              <div>
                <p className="text-2xl font-bold">
                  {isLoading ? (
                    <span className="animate-pulse bg-muted h-8 w-16 rounded block" />
                  ) : (
                    item.value
                  )}
                </p>
                <p className="text-sm text-muted-foreground">{item.label}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
